'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoIcon = function (_React$Component) {
    _inherits(AutoIcon, _React$Component);

    function AutoIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AutoIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutoIcon.__proto__ || Object.getPrototypeOf(AutoIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'auto-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, fill: 'transparent' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Transportation_Cars_car-clouds', 'data-name': 'Transportation / Cars / car-clouds', transform: 'translate(1 1)' },
                    _react2.default.createElement(
                        'g',
                        { id: 'Group_31', transform: 'translate(0)' },
                        _react2.default.createElement(
                            'g',
                            { id: 'car-clouds', transform: 'translate(0)' },
                            _react2.default.createElement('path', { fill: color, id: 'Shape_75', d: 'M201.039,431.687h-5.868a.3.3,0,0,1-.06,0,2.476,2.476,0,0,1-2.057-1.708,2.619,2.619,0,0,1,.617-2.659,2.4,2.4,0,0,1,1.292-.67.461.461,0,0,0,.308-.206,3.179,3.179,0,0,1,2.678-1.465,3.386,3.386,0,0,1,3.187,2.37.468.468,0,0,0,.354.323,2.008,2.008,0,0,1,1.585,1.991,1.949,1.949,0,0,1-.526,1.416A2.233,2.233,0,0,1,201.039,431.687Z', transform: 'translate(-181.1 -424.979)' }),
                            _react2.default.createElement('path', { fill: color, id: 'Shape_76', d: 'M205.671,430.671a2.391,2.391,0,0,1,1.292-.671.459.459,0,0,0,.308-.2,3.177,3.177,0,0,1,2.678-1.462,3.387,3.387,0,0,1,3.187,2.37.468.468,0,0,0,.354.323,2.008,2.008,0,0,1,1.585,1.991,1.949,1.949,0,0,1-.526,1.416,2.239,2.239,0,0,1-1.51.609h-5.868a.6.6,0,0,1-.06,0,2.477,2.477,0,0,1-2.057-1.709,2.617,2.617,0,0,1,.617-2.658Z', transform: 'translate(-204.921 -425.018)' }),
                            _react2.default.createElement('path', { fill: color, id: 'Shape_77', d: 'M194.035,444a.45.45,0,0,1-.44.383h0a.72.72,0,0,0,0,1.438h2.081a.016.016,0,0,1,.014.009,1.853,1.853,0,0,0,1.582,1.18,1.83,1.83,0,0,0,1.72-.95.46.46,0,0,1,.4-.239h5.7a.457.457,0,0,1,.4.239,1.812,1.812,0,0,0,3.193,0,.46.46,0,0,1,.4-.239h.277a.936.936,0,0,0,.916-.835,3.419,3.419,0,0,0-.61-2.725,2.912,2.912,0,0,0-1.994-.959.464.464,0,0,1-.377-.287l-.19-.462a6.849,6.849,0,0,0-6.3-4.313,6.58,6.58,0,0,0-6.433,5.667Zm4.038-2.971a.455.455,0,0,1-.389-.223.5.5,0,0,1-.028-.461,3.615,3.615,0,0,1,6.646,0,.492.492,0,0,1-.027.461.457.457,0,0,1-.39.223Z', transform: 'translate(-188.345 -425.157)', fillRule: 'evenodd' })
                        )
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AutoIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return AutoIcon;
}(_react2.default.Component);

exports.default = AutoIcon;